export default __webpack_public_path__ + "static/media/M3_01.70069be9.jpg";